<template>
  <div class="publicModule-container">
    <div class="publicModule-head">
      <p class="publicModule-title">{{ title }}</p>
      <p class="publicModule-label">{{ lable }}</p>
    </div>
    <slot />
  </div>
</template>

<script>

export default {
  name: 'HomeView',
  props: {
    title: {
      type: String,
      default: ''
    },
    lable: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.publicModule-container {
  width: 100%;
  padding: 50px;
  height: auto;

  .publicModule-head {
    font-size: 48px;
    font-family: PingFangSC, PingFangSC-Semibold;
    font-weight: 600;
    line-height: 48px;
    text-align: left;
    color: #2d2d2d;

    p {
      text-align: center;
    }

    .publicModule-label {
      margin-top: 26px;
      font-size: 32px;
      line-height: 32px;
      color: #fbaa00;
    }
  }
}
</style>

<style lang="scss">
@media (max-width: 768px) {
  .publicModule-container {
    padding: 16px !important;
  }

  .publicModule-head {
    font-size: 24px !important;

    p {
      text-align: left !important;
    }

    .publicModule-label {
      font-size: 18px !important;
      margin-top: 12px !important;
    }
  }
}
</style>
